import { parametroTypes } from "../../types/parametroTypes"

export const getTiposDocumento = ( payload ) => ({
    type: parametroTypes.TIPO_DOCUMENTO_GET_START,
    payload
})

export const resetTiposDocumento = ( payload = [] ) => ({
    type: parametroTypes.TIPO_DOCUMENTO_RESET,
    payload
})

export const getTiposInstEdu = ( payload ) => ({
    type: parametroTypes.TIPO_INST_EDU_GET_START,
    payload
})

export const resetTiposInstEdu = ( payload = [] ) => ({
    type: parametroTypes.TIPO_INST_EDU_RESET,
    payload
})

export const getNacionalidades = ( payload ) => ({
    type: parametroTypes.NACIONALIDAD_GET_START,
    payload
})

export const resetNacionalidades = ( payload = [] ) => ({
    type: parametroTypes.NACIONALIDAD_RESET,
    payload
})
